import { Plugin } from '@nuxt/types'
import { getSappTrackingData, trackScholarship } from '~/lib/utils/utils'
import { SAPPTrackingEvent, SAPPTrackingService } from '~/types/sapp-track'

const sappPlugin: Plugin = ({ $auth }, inject) => {
  const setUtid = async() =>
    window.sapp.setUtid($auth.user?.utid ?? (await window.sapp.getUtid()))

  const methods = {
    async verifyGoal(...args) {
      await setUtid()
      return await window.sapp.verifyGoal(...args)
    },
    async trackApplied(externalScholarshipId, accountId) {
      const data: SAPPTrackingEvent = getSappTrackingData(
        'applied',
        externalScholarshipId,
        accountId
      )
      await setUtid()
      trackScholarship(data)
    },
    async generateTrackingUrl(url: string) {
      await setUtid()
      return await window.sapp.generateTrackingUrl(url)
    }
  } as SAPPTrackingService

  inject('sappTracking', methods)
}

export default sappPlugin
